/**
 * Inline links inside a dictionary value: `{key|visible text}` marks a link whose
 * href the caller resolves from `key` (so URLs stay out of the copy and each
 * language places its own anchor text). Shared by the React page and the Worker
 * prerender. Pure.
 */
export type InlinePart = string | { key: string; text: string };

const LINK = /\{([a-z]+)\|([^{}|]+)\}/g;

export function parseInlineLinks(value: string): InlinePart[] {
  const parts: InlinePart[] = [];
  let last = 0;
  for (const m of value.matchAll(LINK)) {
    if (m.index > last) parts.push(value.slice(last, m.index));
    parts.push({ key: m[1]!, text: m[2]! });
    last = m.index + m[0].length;
  }
  if (last < value.length) parts.push(value.slice(last));
  return parts;
}
